(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["button-custom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('button-custom-block')) {
    customElements.define('button-custom-block', class extends HTMLElement {
      constructor() {
        super();
        // Delegation also works when the theme editor replaces block contents.
        this.addEventListener('click', (event) => {
          const target = event.target;
          if (!(target instanceof Element)) return;
          const dialog = this.querySelector('.bc-dialog');
          if (!dialog) return;
          const opener = target.closest('[data-bc-open]');
          if (opener && this.contains(opener)) {
            event.preventDefault();
            if (!dialog.open) dialog.showModal();
            this.loadPage(dialog);
            return;
          }
          if (target.closest('[data-bc-close]')) {
            dialog.close();
            return;
          }
          // The backdrop retargets clicks to the dialog. Do not dismiss
          // clicks inside its rectangle, including the scrollbar.
          if (target === dialog) {
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right ||
                event.clientY < rect.top || event.clientY > rect.bottom) {
              dialog.close();
            }
          }
        });
        // Native modal dialogs handle Escape, focus containment and return focus.
      }
      async loadPage(dialog) {
        const content = this.querySelector('[data-bc-src]');
        if (!content || content.dataset.loaded === 'true' || this.pageRequest) return;
        const status = this.querySelector('[data-bc-status]');
        status.hidden = false;
        status.textContent = 'Loading page…';
        content.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        this.pageRequest = controller;
        const timeout = window.setTimeout(() => controller.abort(), 20000);
        try {
          // Keep requests on the storefront origin, including theme previews.
          const source = new URL(content.dataset.bcSrc, window.location.origin);
          const url = new URL(source.pathname + source.search, window.location.origin);
          const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
          if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
          const response = await fetch(url.href, {
            credentials: 'same-origin',
            signal: controller.signal,
            headers: { Accept: 'text/html' }
          });
          if (!response.ok) throw new Error('Page request returned HTTP ' + response.status);
          if (new URL(response.url).origin !== window.location.origin) {
            throw new Error('Page redirected to another domain');
          }
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const main = doc.querySelector('#MainContent, main, [role="main"]');
          if (!main || !main.textContent.trim()) throw new Error('Page main content was not found');

          // The host theme supplies global CSS and component definitions.
          // Keep section-local styles but never replay page analytics/scripts.
          main.querySelectorAll('script, base, meta, .section-breadcrumbs').forEach(node => node.remove());
          main.querySelectorAll('*').forEach(node => {
            for (const attribute of Array.from(node.attributes)) {
              if (attribute.name.startsWith('on')) node.removeAttribute(attribute.name);
            }
            for (const name of ['src', 'href', 'poster']) {
              const value = node.getAttribute(name);
              if (!value || value.startsWith('#')) continue;
              const resolved = new URL(value, response.url);
              if (resolved.protocol === 'javascript:') node.removeAttribute(name);
              else node.setAttribute(name, resolved.href);
            }
          });

          // Prefix copied IDs so several Button Custom instances can coexist.
          const prefix = dialog.id + '-page-';
          const ids = new Map();
          main.querySelectorAll('[id]').forEach(node => {
            const old = node.id;
            ids.set(old, prefix + old);
            node.id = prefix + old;
          });
          main.querySelectorAll('*').forEach(node => {
            for (const attr of ['for', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'headers']) {
              if (node.hasAttribute(attr)) {
                node.setAttribute(attr, node.getAttribute(attr).split(/\s+/).map(id => ids.get(id) || id).join(' '));
              }
            }
            const href = node.getAttribute('href');
            if (href && href.startsWith('#') && ids.has(href.slice(1))) {
              node.setAttribute('href', '#' + ids.get(href.slice(1)));
            }
          });
          // Rewrite ID selectors in the section CSS together with their markup.
          main.querySelectorAll('style').forEach(style => {
            style.textContent = style.textContent.replace(/#([a-zA-Z_][\w-]*)/g,
              (match, id) => ids.has(id) ? '#' + ids.get(id) : match);
          });
          content.replaceChildren(...Array.from(main.childNodes));
          content.hidden = false;
          content.dataset.loaded = 'true';
          status.hidden = true;
        } catch (error) {
          if (!this.isConnected) return;
          status.hidden = false;
          status.textContent = 'Unable to load the page. Close and reopen to retry, or use the full-page link below.';
          console.warn('[Button Custom] Could not load modal page:', error);
        } finally {
          window.clearTimeout(timeout);
          content.removeAttribute('aria-busy');
          if (this.pageRequest === controller) this.pageRequest = null;
        }
      }
      disconnectedCallback() {
        if (this.pageRequest) this.pageRequest.abort();
        const dialog = this.querySelector('.bc-dialog');
        if (dialog && dialog.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
